export default {
    secondAuth: {
        zipcode: 'PLZ',
        birthday: 'Geburtsdatum',

        zipcodeInvalid: 'Die Postleitzahl stimmt nicht mit der Postleitzahl in der Anmeldung überein.',
        birthdayInvalid: 'Das Geburtsdatum stimmt nicht mit dem Geburtsdatum in der Anmeldung überein.',
    },
    secondAuthInfo: 'Bitte geben Sie {param} ein um die Anmeldung einzusehen.',
    secondAuthInfozipcode: 'Ihre Postleitzahl',
    secondAuthInfobirthday: 'Ihr Geburtsdatum',
    submitSecondAuth: 'Absenden',

    id: 'Anmeldung Nr.',
    date: 'Anmeldedatum',

    documents: "Anmeldungsdokumente",
    contractualInfo: "Druckansicht",
}
